module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-five.990415cb.png";